import { getFormattedDate } from "../components/getFormattedDate";
import {
  ADMIN_REPORT,
  ALAMAHA,
  CHECKOUT,
  LWW_QRCODE,
  LWW_TICKETS,
  SOURCE,
} from "./constants";
import { http } from "./httpServices";

//   export function getAquaSlotDetails(date: string) {
//     return http.get(`${CHECKOUT}${AQUA_CALENDAR}`, { params: { date } });
//   }

//   export function getAgentList() {
//     return http.get(`${USER}${AGENT_LIST}`);
//   }

export function getLwwTickets(
  productId: string,
  type: string,
  searchText: string,
  day: string,
  date: string,
  endDate: string,
  page: number,
  limit: number,
  skipCashId: number
) {
  const params: Record<string, string> = {
    type,
    searchText,
    page: page.toString(),
    limit: limit.toString(),
  };
  if (productId) {
    params.productId = productId;
  }

  if (day && day != "custom") {
    params.day = day;
  }

  if (date) {
    params.date = getFormattedDate(date, "YYYY-MM-DD");
  }

  if (endDate) {
    params.endDate = getFormattedDate(endDate, "YYYY-MM-DD");
  }

  if (skipCashId) {
    params.skipCashId = skipCashId.toString();
  }
  return http.get(`${ALAMAHA}${LWW_TICKETS}`, { params });
}

export function getQRCode(id: string) {
  const params: Record<string, string> = {
    id,
  };
  return http.get(`${CHECKOUT}${LWW_QRCODE}`, { params });
}

export function downloadReport(
  agentId: string,
  date: string,
  filter: string,
  searchText: string
) {
  return http.get(`${ALAMAHA}${SOURCE}${ADMIN_REPORT}`, {
    responseType: "blob",
    params: {
      agentId,
      date,
      filter,
      searchText,
    },
  });
}

export function getAvailableCount() {
  return http.get(`${ALAMAHA}/staticQR`);
}
